import { CtaButtonType, CtaForm } from '@pairy/sheard/types';
import { useAtomValue } from 'jotai';
import { useState } from 'react';
import { useMediaQuery } from 'react-responsive';

import { GetBulkFilePreviewResponse } from '../../../types/file';
import RootLayout from '../../@common/RootLayout';
import BulkMobileViewer from '../../BulkViewer/Mobile';
import MobilePageNavigation from '../../@common/PageNavigationDrawer/Mobile';
import { isPreviewFormSubmittedAtom } from '../index.atom';
import { getBlindPages } from '../../BulkViewer/index.util';
import useUpdateRenderThumbnails from '../../../hooks/useUpdateRenderThumbnails';
import { MessageBoxItemType } from '../../PdfViewer/index.types';

interface Props {
  data?: GetBulkFilePreviewResponse;
  ctaButtonList?: CtaButtonType[];
  ctaForm?: CtaForm;
  messageBoxItems?: MessageBoxItemType[];
  translateKoToEn: (item: string) => string;
}

const MobilePdfPreview = ({
  ctaForm,
  data,
  ctaButtonList,
  messageBoxItems,
  translateKoToEn,
}: Props) => {
  if (!data) {
    return null;
  }

  const [isMobileDrawerOpen, setIsMobileDrawerOpen] = useState(false);
  const isSubmitted = useAtomValue(isPreviewFormSubmittedAtom);

  const pageNavigationInfo = data?.file?.thumbnails.map(
    ({ page, thumbnail, originalHeight, originalWidth, imageSources }) => {
      return {
        page,
        thumnail: thumbnail,
        originalWidth,
        originalHeight,
        imageSources,
      };
    },
  );

  /** NOTE: 렌더링하는 곳에서 user agent 체킹하므로 landscape만 체크 */
  const isMobileLandscape = useMediaQuery({
    query: '(orientation: landscape)',
  });

  const { file, user } = data;

  const blindStatus = ctaForm?.blind;
  const blindPage = ctaForm?.page;
  const blindPages = isSubmitted
    ? []
    : getBlindPages({
        blindStatus,
        blindPage,
        totalPages: pageNavigationInfo?.length,
      });

  const { updateNextThumbnails, updatePrevThumbnails } =
    useUpdateRenderThumbnails({
      defaultThumbnails: data?.file?.thumbnails,
    });

  return (
    <RootLayout mode="mobile">
      <BulkMobileViewer
        file={file}
        user={user}
        translateKoToEn={translateKoToEn}
        ctaButtonList={ctaButtonList}
        messageBoxItems={messageBoxItems}
        updateNextThumbnails={updateNextThumbnails}
        updatePrevThumbnails={updatePrevThumbnails}
        setIsMobileDrawerOpen={setIsMobileDrawerOpen}
        isPreview
        isMobileLandscape={isMobileLandscape}
      />

      <MobilePageNavigation
        translateKoToEn={translateKoToEn}
        isMobileDrawerOpen={isMobileDrawerOpen}
        setIsMobileDrawerOpen={setIsMobileDrawerOpen}
        pages={pageNavigationInfo}
        blindPages={blindPages}
        isMobileLandscape={isMobileLandscape}
      />
    </RootLayout>
  );
};

export default MobilePdfPreview;
